import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';

class Desktop extends Component {
  getElements = () => {
    const { meta } = this.props;

    let paginatorElements = [];
    const totalPage = meta.last_page;
    const currentPage = meta.current_page;

    if (totalPage <= 5) {
      for (let i = 1; i <= totalPage; i++) {
        paginatorElements.push(i);
      }

      return { paginatorElements, totalPage, currentPage };
    }

    switch (currentPage) {
      case 1:
      case 2:
      case 3: {
        paginatorElements.push(1, 2, 3, 4, 5, '...');
        break;
      }
      case totalPage:
      case totalPage - 1:
      case totalPage - 2: {
        paginatorElements.push('...', totalPage - 4, totalPage - 3, totalPage - 2, totalPage - 1, totalPage);
        break;
      }
      default: {
        paginatorElements.push('...', currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2, '...');
        break;
      }
    }

    return { paginatorElements, totalPage, currentPage };
  }

  render() {
    const { paginatorElements, currentPage, totalPage } = this.getElements();

    return(
      <div className="paginator-footer paginator-footer--desktop d-none d-xl-block">
        <nav>
          <Pagination
            className="pagination justify-content-end justify-content-sm-end mb-0"
            listClassName="justify-content-end mb-0"
          >
            <PaginationItem className={(currentPage === 1 ? 'disabled' : 'cursor-pointer')}>
              <PaginationLink
                onClick={
                  e => {
                    e.preventDefault();
                    this.props.changePage(1);
                  }
                }
              >
                <i className="fas fa-angle-double-left" />
                <span className="sr-only">
                        <FormattedMessage id="messages.first" />
                      </span>
              </PaginationLink>
            </PaginationItem>
            <PaginationItem className={(currentPage === 1 ? 'disabled' : 'cursor-pointer')}>
              <PaginationLink
                onClick={
                  e => {
                    e.preventDefault();
                    this.props.changePage(currentPage - 1);
                  }
                }
                tabIndex="-1"
              >
                <i className="fas fa-angle-left" />
                <span className="sr-only">
                        <FormattedMessage id="messages.previous" />
                      </span>
              </PaginationLink>
            </PaginationItem>
            {
              paginatorElements.length > 0 && paginatorElements.map(
                (pageNumber, index) => {
                  let activeClass = pageNumber === currentPage ? 'active' : '';
                  let disabledClass = pageNumber === '...' ? 'disabled' : '';

                  return <PaginationItem
                    key={ index }
                    className={(`${activeClass} ${disabledClass}`)}>
                    <PaginationLink
                      id={ `page${index}` }
                      onClick={
                        e => {
                          e.preventDefault();
                          if ( pageNumber !== currentPage ) {
                            this.props.changePage(pageNumber);
                          }
                        }
                      }
                      value={ pageNumber }
                    >
                      { pageNumber }
                    </PaginationLink>
                  </PaginationItem>
                }
              )
            }
            <PaginationItem className={(currentPage === totalPage ? 'disabled' : 'cursor-pointer')}>
              <PaginationLink
                onClick={
                  e => {
                    e.preventDefault();
                    this.props.changePage(currentPage + 1);
                  }
                }
              >
                <i className="fas fa-angle-right" />
                <span className="sr-only">
                      <FormattedMessage id="messages.next" />
                    </span>
              </PaginationLink>
            </PaginationItem>
            <PaginationItem className={(currentPage === totalPage ? 'disabled' : 'cursor-pointer')}>
              <PaginationLink
                onClick={
                  e => {
                    e.preventDefault();
                    this.props.changePage(totalPage);
                  }
                }
              >
                <i className="fas fa-angle-double-right" />
                <span className="sr-only">
                      <FormattedMessage id="messages.last" />
                    </span>
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </nav>
      </div>
    )
  }
}

export { Desktop }
